import React from 'react';

// Component and Utils
import { CommonModal } from '../../../../components/Popups/CommonModal';
import { useCommonModalHOCInit } from './hook';

// TODO !!!!!!!!!!!!
// Если получен пустой ответ метода или при запросе получили ошибку - текст со стоимостью семьи в попапе не отображать
// family/price

const CommonModalHOC = () => {
  const {
    currentPopupData,
    isShowCrossButton,
    resolveAdditionalActions,
    resolveActions,
    size,
    isOpen,
    popupRequestStatus,
    step,
  } = useCommonModalHOCInit();

  return (
    <CommonModal
      onConfirm={resolveActions[step]}
      onAdditionalConfirm={resolveAdditionalActions[step]}
      isOpen={isOpen}
      isLoading={popupRequestStatus.isLoading}
      isCloseButtonVisible={isShowCrossButton}
      data={currentPopupData}
      size={size}
    />
  );
};

export { CommonModalHOC };
